import { contracts } from '@arcotech-services/mfe-communicator'

export const Contracts = {
  Auth: contracts.backoffice.request.auth,
  BusinessUnits: contracts.backoffice.request.businessUnits,
  UserInfo: contracts.backoffice.request.userInfo,
  UserPermissions: contracts.backoffice.request.userPermissions
} as const

export const MFE_SHARED = '__ARCO_MFE_SHARED__' as const
export const MFE_EVENTS = '__microfrontend_events__' as const
export const MFE_OBSERVERS = '__microfrontend_observers__' as const
export const MFE_WATCHERS = '__microfrontend_watchers__' as const
export const MFE_ASYNC_RESOLVERS = '__microfrontend_async_resolvers__' as const
